import React from 'react';

/**
 * Renders the V1 dashboard inside a real mobile-width iframe so production
 * @media rules apply (scaled desktop previews do not match V1 mobile).
 */
const MarketingMobileFrame = ({ showElearning = false, className = '' }) => {
    const params = new URLSearchParams({
        frame: 'mobile',
        capture: '1',
    });
    if (showElearning) {
        params.set('elearning', '1');
    }

    return (
        <iframe
            title="Oola Framework V1 — mobile preview"
            className={`marketing-phone-iframe ${className}`.trim()}
            src={`/marketing-assets?${params.toString()}`}
            scrolling="yes"
        />
    );
};

export default MarketingMobileFrame;
